import script from "./Popover.vue?vue&type=script&setup=true&lang=js"
export * from "./Popover.vue?vue&type=script&setup=true&lang=js"

import "./Popover.vue?vue&type=style&index=0&id=f5d313d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5d313d6"]])

export default __exports__